export const engagementAppGroupIdCanvasLastEditWorkflowId =
  "/engagement/:app_group_id/canvas_last_edit/:workflow_id";
